export const rankingBoards = [
  {
    id: "weekly-hot",
    title: "本周合集热度榜",
    subtitle: "按过去七天的阅读量与收藏数综合排序",
    updated: "2026-09-08",
    items: [
      {
        rank: 1,
        title: "本周网络热梗与讨论合集",
        topicId: "weekly-trend-digest",
        metric: "阅读 21.3 万",
        note: "一周内讨论方向两次转折，目录完整记录了扩散路径。",
      },
      {
        rank: 2,
        title: "暑期档剧集口碑盘点：从开分到收官",
        topicId: "summer-lineup-2026",
        metric: "阅读 18.6 万",
        note: "同档期作品横向对比，口碑变化一目了然。",
      },
      {
        rank: 3,
        title: "巡演现场名场面合集：安可与大合唱",
        topicId: "tour-live-moments",
        metric: "阅读 14.2 万",
        note: "同一曲目的多城现场版本并列呈现。",
      },
      {
        rank: 4,
        title: "综艺整季名场面一次看够",
        topicId: "variety-season-highlights",
        metric: "阅读 13.5 万",
        note: "按时间点跳转，跳过冗长铺垫。",
      },
      {
        rank: 5,
        title: "舞台直拍与回归打歌合集",
        topicId: "stage-comeback-cut",
        metric: "阅读 11.7 万",
        note: "多机位直拍对照，编舞细节更清楚。",
      },
    ],
  },
  {
    id: "editor-picks",
    title: "编辑部精选盘点",
    subtitle: "由内容整理组人工挑选的当季专题",
    updated: "2026-09-05",
    items: [
      {
        rank: 1,
        title: "决赛夜关键回合复盘合集",
        topicId: "finals-key-possession",
        metric: "收藏 1.2 万",
        note: "只保留改变比赛走向的回合，信息密度高。",
      },
      {
        rank: 2,
        title: "影展红毯与获奖名单目录",
        topicId: "film-festival-awards",
        metric: "收藏 9,640",
        note: "按奖项类别分组，查名单最省事。",
      },
      {
        rank: 3,
        title: "城市夜宵地图盘点",
        topicId: "city-night-market-map",
        metric: "收藏 8,110",
        note: "按时段标注人流，实用性强。",
      },
      {
        rank: 4,
        title: "新品发布会看点合集",
        topicId: "launch-event-recap",
        metric: "收藏 7,320",
        note: "参数并列呈现，避免被涨幅误导。",
      },
    ],
  },
  {
    id: "fresh-arrivals",
    title: "最新上线专题榜",
    subtitle: "按整理完成时间倒序",
    updated: "2026-09-09",
    items: [
      {
        rank: 1,
        title: "本周网络热梗与讨论合集",
        topicId: "weekly-trend-digest",
        metric: "上线 2 天",
        note: "每周固定更新，覆盖当周主要讨论方向。",
      },
      {
        rank: 2,
        title: "巡演现场名场面合集：安可与大合唱",
        topicId: "tour-live-moments",
        metric: "上线 6 天",
        note: "本轮巡演的城市场次已全部归档。",
      },
      {
        rank: 3,
        title: "暑期档剧集口碑盘点：从开分到收官",
        topicId: "summer-lineup-2026",
        metric: "上线 12 天",
        note: "收官后补充了完整的名场面清单。",
      },
    ],
  },
];